/**
 * The groups the icon picker splits its catalogue into, in the order it lists
 * them.
 *
 * Here rather than beside the icons themselves because the icons are lucide
 * components and cannot be imported from `shared/`, while the German names of
 * the groups live in `shared/locales/de/controls.ts`. Both sides read this
 * list, so a group added on one and forgotten on the other is a build error.
 */
export const ICON_GROUP_IDS = [
  'building',
  'rooms',
  'sanitary',
  'kitchen',
  'structure',
  'electric',
  'climate',
  'tools',
  'devices',
  'outdoor',
  'documents',
  'misc',
] as const

export type IconGroupId = (typeof ICON_GROUP_IDS)[number]
